import * as Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import {createPinia} from 'pinia';
import vClickOutside from "click-outside-vue3";
import DChooseParamsV2 from "@components/organisms/DChooseParamsV2.vue";
import VueSmoothScroll from "vue3-smooth-scroll";
import Notifications from '@kyvg/vue3-notification';
import velocity from 'velocity-animate'

$(window).on('load', function(e) {
  const mountEl = document.querySelector('#choose');
  const app = Vue.createApp(DChooseParamsV2, {...mountEl.dataset});
  app.use(VueAxios, axios).use(createPinia()).use(VueSmoothScroll).use(vClickOutside).use(Notifications, { velocity });
  app.mount('#choose');
})
